var map = {
	"./AdelaideThunderbirds.png": "MyKw",
	"./Giants.png": "EFQB",
	"./Magpies.png": "Mzp/",
	"./MelbourneMavericks.png": "E+Ih",
	"./MelbourneVixens.png": "3loN",
	"./NSWSwifts.png": "nFgS",
	"./QLDFirebirds.png": "b3kk",
	"./SEM.png": "B9YM",
	"./SunshineCoastLightning.png": "kjBY",
	"./WestCoastFever.png": "6wQr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 1